import {
  SeasonEligibility,
  So5LeaderboardSeasonality,
  Sport,
} from '#src/__generated__/globalTypes.ts';
import type { unitMapping } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

import { AllSeasons2025, AllSeasons2026 } from './AllSeasons.tsx';
import { InSeason2025, InSeason2026 } from './InSeason.tsx';

const IconBySeasonalityBySport = {
  [Sport.FOOTBALL]: {
    [So5LeaderboardSeasonality.ALL_SEASONS]: AllSeasons2026,
    [So5LeaderboardSeasonality.IN_SEASON]: InSeason2026,
    [SeasonEligibility.CLASSIC]: AllSeasons2026,
  },
  [Sport.NBA]: {
    [So5LeaderboardSeasonality.ALL_SEASONS]: AllSeasons2025,
    [So5LeaderboardSeasonality.IN_SEASON]: InSeason2025,
    [SeasonEligibility.CLASSIC]: AllSeasons2025,
  },
  [Sport.BASEBALL]: {
    [So5LeaderboardSeasonality.ALL_SEASONS]: AllSeasons2025,
    [So5LeaderboardSeasonality.IN_SEASON]: InSeason2025,
    [SeasonEligibility.CLASSIC]: AllSeasons2025,
  },
};

type Props = {
  sport: Sport;
  seasonality: So5LeaderboardSeasonality | SeasonEligibility;
  color?: Color;
  size?: keyof typeof unitMapping;
};

export const SeasonalityIcon = ({
  sport,
  seasonality,
  size = 2,
  color,
}: Props) => {
  const Component = IconBySeasonalityBySport[sport][seasonality];
  return <Component size={size} color={color} />;
};
